const AUTH_GET_TOKEN = "auth::get-token::fetch";
const AUTH_GET_TOKEN_FAILURE = "auth::get-token::failure";
const AUTH_GET_TOKEN_SUCCESS = "auth::get-token::success";
const AUTH_TOKEN_CHANGE = "auth::token::change";
const USER_LOGIN = "auth::user::login";
const USER_LOGOUT = "auth::user::logout";

function authTokenChangeAction(token) {
  return {
    payload: { token },
    type: AUTH_TOKEN_CHANGE,
  };
}

function userLogin(user, response = {}, message = "") {
  return {
    payload: {
      message,
      response,
      user,
    },
    type: USER_LOGIN,
  };
}

const logoutUser = {
  type: USER_LOGOUT,
  payload: {
    sessionExpired: false,
    statusCode: 401,
  },
};

export {
  AUTH_GET_TOKEN,
  AUTH_GET_TOKEN_FAILURE,
  AUTH_GET_TOKEN_SUCCESS,
  AUTH_TOKEN_CHANGE,
  authTokenChangeAction,
  logoutUser,
  USER_LOGIN,
  USER_LOGOUT,
  userLogin,
};
